import type { DynamicFiltersAPIResponse } from '../../utils/api/filtersAPIResponseTypes';
import { APIStatusEnum } from './APIStatusEnum';

export const dynamicFiltersResponseDefault: DynamicFiltersAPIResponse = {
  status: APIStatusEnum.NORESULTS,
};
